function kanaryNestSlider(slideInterval) {
  [...document.querySelectorAll('.slider-wrapper--kanary-nest')]?.forEach( slider => {
    new Splide( slider, {
      type: 'loop',
      speed: 2000,
      autoplay: true,
      interval: slideInterval,
      pauseOnHover: false,
      pauseOnFocus: false,
      whell: false,
      drag: false
    } ).mount();
    slider.style.cssText += '--slideInterval: ' + slideInterval/1000 + 's';
  })
}

document.addEventListener( 'DOMContentLoaded', function() {
  kanaryNestSlider(30000);
} );